<template>
  <v-app id="app">
    <div v-if="!signedIn" class="text-center mt-5 pt-5">
      <amplify-authenticator :authConfig="{ signInConfig: { isSignUpDisplayed: false } }" />
    </div>
    <div v-if="signedIn">
      <navbar/>
      <router-view />
    </div>
    <v-snackbar v-model="snackbarToggle" :timeout="3000" :color="snackbarColor">
      {{ snackbarText }}
    </v-snackbar>
  </v-app>
</template>

<script>
/* eslint-disable */
import navbar from '@/components/Navbar';
import { AmplifyEventBus } from 'aws-amplify-vue';
import { Auth } from 'aws-amplify';

export default {
  name: 'App',
  components: {
    navbar,
  },
  async beforeCreate() {
    try {
      const user = await Auth.currentAuthenticatedUser();
      if (user.signInUserSession.idToken.payload['cognito:groups'].includes('clients')) {
        this.signedIn = true;
        this.init();
      } else {
        this.$Amplify.Auth.signOut()
          .then(() => AmplifyEventBus.$emit('authState', 'signedOut'))
          .catch((e) => console.error(e));
      }
    } catch (err) {
      this.signedIn = false;
    }
    AmplifyEventBus.$on('authState', async (info) => {
      if (info === 'signedIn') {
        const user = await Auth.currentAuthenticatedUser();
        if (user.signInUserSession.idToken.payload['cognito:groups'].includes('clients')) {
          this.signedIn = true;
          this.init();
        } else {
          this.$Amplify.Auth.signOut()
            .then(() => AmplifyEventBus.$emit('authState', 'signedOut'))
            .catch((e) => console.error(e));
        }
      } else {
        this.signedIn = false;
      }
    });
  },
  data() {
    return {
      signedIn: false,
      snackbarText: 'Success',
      snackbarToggle: false,
      snackbarColor: 'success',
    };
  },
  methods: {
    async init() {
      if (this.signedIn) {
        const user = await Auth.currentAuthenticatedUser();
        const groups = user.signInUserSession.idToken.payload['cognito:groups'];
        groups.sort((a, b) => b.length - a.length);
        const groupId = groups[0];
        this.$store.commit('fetchDetails', groupId);
        this.$store.commit('fetchStatusItems');
        this.$store.commit('fetchPriorityItems');
        // this.$store.commit('fetchProductItems', groupId);
      }

      this.$root.$on('snackbar-flash', (event) => {
        this.snackbarText = 'text' in event ? event.text : 'Success';
        this.snackbarColor = 'color' in event ? event.color : 'success';
        this.snackbarToggle = true;
      });
    },
  },
  watch: {
    $route(to, from) {
      document.title = to.meta.title || 'T2 Services Client Portal';
    },
  },
  created () {
    document.title = this.$route.meta.title || 'T2 Services Client Portal';
  },
};
</script>

<style>
.hover-cursor-pointer:hover {
  cursor: pointer;
}
</style>
